import Image from '@/components/ui/image'
import { isPrint } from '@/utils/print'
import { cx } from '@/utils/strings'
import { useIntersectionObserver } from 'usehooks-ts'
import ShieldLoader from './shield-loader'

// videos supported:
// vimeo example     https://player.vimeo.com/video/632391847
// youtube example   https://www.youtube.com/embed/YhIwT4AMvm0

export default function Video({ fields }) {
  const { url, aspectRatio } = fields
  // default params dont work because stinker contentful sends null instead of undefined
  const aspectRatioWithDefault = aspectRatio || '16 / 9'

  const isprint = isPrint()

  const extractVideoUrl = (url: string) => {
    const youtubeMatch = url.match(/youtube\.com\/embed\/([\w-]{11})/)
    if (youtubeMatch) return `https://img.youtube.com/vi/${youtubeMatch[1]}/hqdefault.jpg`

    const vimeoMatch = url.match(/vimeo\.com\/video\/(\d+)/)
    if (vimeoMatch) return `https://vumbnail.com/${vimeoMatch[1]}.jpg`

    return ''
  }

  if (isprint)
    return (
      <div className="flex justify-center">
        <Image link={{ url }} showCaption image={{ fields: { title: url, publicUrl: extractVideoUrl(url) } }} />
      </div>
    )
  const { isIntersecting, ref: videoContainer } = useIntersectionObserver({ freezeOnceVisible: true })
  return (
    <div
      className={cx(
        'w-full',
        aspectRatioWithDefault === '16 / 9' && `aspect-16/9`,
        aspectRatioWithDefault === '9 / 16' && `aspect-9/16`,
        aspectRatioWithDefault === '4 / 3' && `aspect-4/3`,
        aspectRatioWithDefault === '1 / 1' && `aspect-1/1`
      )}
      data-testid="videoplayer"
      ref={videoContainer}
    >
      {isIntersecting ? (
        <>
          {/* Player ratio: 100 / (1280 / 720) */}
          {url?.toLowerCase()?.includes('vimeo') && (
            <>
              <script
                src="https://player.vimeo.com/api/player-2.26.0.js"
                integrity="sha384-cspqYTlnJGgea0pMlbvC1pz6dOPp5NrryEqRF400Iiukq7L+BeYZenBZ+9Ee9I4F"
                crossOrigin="anonymous"
              />

              <iframe
                className="w-full h-full"
                src={`${url}?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479`}
                title="Bitwarden video"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                sandbox="allow-scripts allow-same-origin allow-popups"
                frameBorder="0"
              />
            </>
          )}
          {url?.toLowerCase()?.includes('youtube') && (
            <iframe
              className="w-full h-full"
              src={`${url}?rel=0&modestbranding=1`}
              title="Bitwarden video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sandbox="allow-scripts allow-same-origin allow-popups"
              frameBorder="0"
            />
          )}
        </>
      ) : (
        <ShieldLoader className="w-full h-full" />
      )}
    </div>
  )
}
